import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import PagesRouter from 'pages/PagesRouter';
import Layout from 'layout';
import theme from 'theme';
import GlobalStyles from 'globalStyles';

const App = () => {

	return (
		<BrowserRouter>
			<GlobalStyles/>
			<ThemeProvider theme={theme}>
				<Layout>
					<PagesRouter />
				</Layout>
			</ThemeProvider>
		</BrowserRouter>
	);
};

export default App;
